import { render } from "./AboutCompass.vue?vue&type=template&id=234b8177"
import script from "./AboutCompass.vue?vue&type=script&lang=js"
export * from "./AboutCompass.vue?vue&type=script&lang=js"

import "./AboutCompass.vue?vue&type=style&index=0&id=234b8177&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__